/* Public aggregate feed only. Never put Shopify credentials into a theme. */
(() => {
  const root = document.querySelector('[data-be-batches]');
  if (!root || !root.dataset.beEndpoint) return;
  const endpoint = root.dataset.beEndpoint.replace(/\/$/, '');
  root.querySelectorAll('[data-be-batch-stage]').forEach((stage) => {
    stage.dataset.beFallback = stage.textContent;
  });
  const heading = root.querySelector('[data-be-batch-heading]');
  const headingFallback = heading && heading.textContent;
  const headingPrefix = root.querySelector('[data-be-batch-heading-prefix]');
  const prefixFallback = headingPrefix && headingPrefix.textContent;
  let stream;
  let freshnessTimer;
  const apply = (payload) => {
    clearTimeout(freshnessTimer);
    const timestamp = Date.parse(payload.generated_at);
    const age = Date.now() - timestamp;
    const ready = payload.ready && Array.isArray(payload.rows) && Number.isFinite(age) && age < 180000;
    root.dataset.beReady = String(Boolean(ready));
    if (heading) {
      const active = ready && payload.rows.find((row) => row.id === payload.active_batch);
      let text = headingFallback;
      if (headingPrefix) headingPrefix.textContent = prefixFallback;
      if (ready && !active) {
        text = 'Sold out';
        if (headingPrefix) headingPrefix.textContent = 'Status:';
      }
      else if (active) {
        // This template launches with 10/9; previews must already show its ship date.
        const launch = payload.rows.find((row) => row.date === root.dataset.beLaunchBatch);
        const next = active.date < root.dataset.beLaunchBatch ? launch : active;
        if (next && next.status !== 'sold_out') {
          const [, month, day] = next.date.split('-');
          text = `${Number(month)}/${Number(day)}`;
        }
      }
      heading.textContent = text;
    }
    root.querySelectorAll('[data-be-batch-date]').forEach((row) => {
      const value = ready && payload.rows.find((r) => r.date === row.dataset.beBatchDate);
      const unlocked = !row.dataset.beShowAfter || (ready && payload.rows.some((prior) =>
        prior.date === row.dataset.beShowAfter && prior.status === 'sold_out'));
      const visibleValue = unlocked && value;
      const label = row.querySelector('[data-be-batch-percent]');
      if (label) {
        // A stale percentage must disappear, including an old SOLD OUT label.
        label.textContent = visibleValue ? (
          row.dataset.beUnitLabel && visibleValue.status !== 'sold_out'
            ? `${visibleValue.percent_sold}% ${row.dataset.beUnitLabel}` : visibleValue.label
        ) : (label.dataset.beFallback || '');
        label.hidden = !visibleValue && !label.dataset.beFallback;
      }
      const stage = row.querySelector('[data-be-batch-stage]');
      if (stage) {
        stage.textContent = value ? ({ in_transit: 'In transit', in_production: 'In production',
          ready: 'Ready to ship', awaiting_materials: 'Awaiting materials',
          sold_out: 'SOLD OUT' })[value.status] || '' : stage.dataset.beFallback;
      }
      row.dataset.beActive = String(Boolean(visibleValue && visibleValue.active));
      if (value) row.dataset.beStatus = value.status;
      else delete row.dataset.beStatus;
    });
    // Use physical allocation, not a rounded percentage or a fixed remaining count:
    // the first reserved unit can still be displayed as 0% reserved.
    const launch = ready && payload.rows.find((row) => row.date === root.dataset.beLaunchBatch);
    const priorSoldOut = ready && payload.rows.some((row) =>
      row.date < root.dataset.beLaunchBatch && row.status === 'sold_out');
    root.hidden = !(launch && priorSoldOut && Number.isFinite(launch.allocated) && launch.allocated > 0);
    if (ready) freshnessTimer = setTimeout(() => apply({ ready: false }), Math.max(1, 180000 - age));
  };
  const poll = async () => {
    if (document.hidden) return;
    try {
      const response = await fetch(`${endpoint}/api/bes1032/status`, {
        cache: 'no-store', signal: AbortSignal.timeout(8000)
      });
      apply(await response.json());
    } catch (_) {
      // The freshness timer clears old values if an outage persists.
    }
  };
  const connect = () => {
    if (document.hidden || stream || !window.EventSource) return;
    stream = new EventSource(`${endpoint}/api/bes1032/events`);
    stream.onmessage = (event) => {
      try { apply(JSON.parse(event.data)); } catch (_) { /* malformed data ignored */ }
    };
    stream.onerror = () => {
      stream.close();
      stream = null;
      // Polling remains active when streaming is unavailable or at capacity.
    };
  };
  apply({ ready: false });
  poll();
  connect();
  const timer = setInterval(poll, 15000);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) { if (stream) stream.close(); stream = null; }
    else { poll(); connect(); }
  });
  window.addEventListener('pagehide', () => {
    clearInterval(timer);
    clearTimeout(freshnessTimer);
    if (stream) stream.close();
  }, { once: true });
})();
